// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"7cbffc23","453":"6d954c7b","457":"bb650fe4","672":"c8185c4f","823":"c7c85f32","833":"cdf73b2d"}[chunkId] + ".chunk.js";
};